import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    chatUser: null,
};
const chatSlice = createSlice({
    name: 'chat',
    initialState: initialState,
    reducers: {
        setChatUser: (state, action) => {
            state.chatUser = action.payload;
        },
    },

});

export const { setChatUser } = chatSlice.actions;
const chatReducer = chatSlice.reducer;
export default chatReducer;
